import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {GatewayOPEEnum} from "./GatewayOPEEnum";
import {GatewayPendingConfigPayloadDTO} from "../gateway-pending-config/GatewayPendingConfigPayloadDTO";

/**
 * O Inner Class
 */
class O {
  gatewayId!: number;
  updateTs?: string;

  // The resulting draft: the gateway block just proposed plus any device already drafted.
  payload!: GatewayPendingConfigPayloadDTO;
}

/**
 * I Inner Class
 */
class I {
  id!: number;
  name!: string;
  typeId!: number;
  sendingCron!: string;
  macAddress?: string;
}

export class PutGatewayCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(GatewayOPEEnum.PutGateway);
    this.i = new I();
    this.o = new O();
  }
}
